import React from 'react';
import { SelectControlMethod } from './SelectControlMethod';
import { SelectRotation } from './SelectRotation';
import { SelectShaftLength } from './SelectShaftLength';
import { SelectStartingMethod } from './SelectStartingMethod';
export function EngineFilters({ productFilterOptions, variantsOfProduct, }) {
    return (React.createElement(React.Fragment, null,
        React.createElement(SelectRotation, { productFilterOptions: productFilterOptions, variantsOfProduct: variantsOfProduct }),
        React.createElement(SelectShaftLength, { productFilterOptions: productFilterOptions, variantsOfProduct: variantsOfProduct }),
        React.createElement(SelectStartingMethod, { productFilterOptions: productFilterOptions, variantsOfProduct: variantsOfProduct }),
        React.createElement(SelectControlMethod, { productFilterOptions: productFilterOptions, variantsOfProduct: variantsOfProduct })));
}
